export default __webpack_public_path__ + "static/media/position.9ad5eae0.svg";